import { Button, Dialog, Grid, Grow, Icon, IconButton, makeStyles, Typography } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import useCardLevels from '../../hooks/modules/cardlevels/useCardLevels';
import { isFormValid, onGetFormData, onGetSelectedFormData, onInitForm, onSetErrorsToForm } from '../../utils/utility';
import RoundedButton from '../Actions/RoundedButton';
import DisplayError from '../DisplayError';
import InputForm from '../Forms/InputForm';
import {QRCodeCanvas} from 'qrcode.react';
import { config } from '../../utils/config';
import { blueGrey, grey } from '@material-ui/core/colors';


const ProgramQRModal = (props) => {

    const classes = useStyles()
    const {open, onClose, origin, onCompleted, actions} = props
    const [busy, setBusy] = useState(false)


    const cardlevelManager = useCardLevels()

    const [form, setForm] = useState(JSON.parse(JSON.stringify(form_data)))

    useEffect(() => {
        if(!open){

        }else{
            let _form = onInitForm(form_data, origin)
            setForm(_form)
            setBusy(false)
        }
    }, [open, origin])

    const isnew = origin?.qrCode === null || origin?.qrCode === undefined || origin?.qrCode === ''


    const onChangeForm = (data) => {
        let temp = { ...form }
        const id = data.config.id
        temp[id] = { ...data }
        setForm(temp)
    }

    const onGetQRImage = () => {
        let response = ''
        const qrCodeURL = document.getElementById('qrCodeFlexia')
          .toDataURL("image/png")
        let imageData = qrCodeURL.split('data:image/png;base64,')
        response = imageData[1]
        return response
    }

    const onDownloadHDQRImage = () => {
        let response = ''
        const qrCodeURL = document.getElementById('qrCodeFlexia')
          .toDataURL("image/png")
        var a = document.createElement("a")
        a.href = qrCodeURL
        a.download = "qrCode512.png"
        a.click()
        a.remove()
        //let imageData = qrCodeURL.split('data:image/png;base64,')
        //response = imageData[1]
        //return response
    }

    const onDownloadSDQRImage = () => {
        let response = ''
        const qrCodeURL = document.getElementById('qrCodeFlexiaSmall')
          .toDataURL("image/png")
        var a = document.createElement("a")
        a.href = qrCodeURL
        a.download = "qrCode256.png"
        a.click()
        a.remove()
        //let imageData = qrCodeURL.split('data:image/png;base64,')
        //response = imageData[1]
        //return response
    }

    const onUpdateCardLevel = async() => {
        if(busy) return

        const errors = isFormValid(form)
        /// Check if the form is valid
        if(errors && errors.length){
            console.log(errors)
            const new_form = onSetErrorsToForm(form, errors)
            setForm(new_form)
            return
        }
        let data2send = isnew ? onGetFormData(form) : onGetSelectedFormData(form, origin)

        
        const imageURL = onGetQRImage()
        data2send.qrCode = imageURL
        console.log(origin)
        console.log(data2send)

        setBusy(true)
        try {
            await actions.updateQRProgram(origin?.idProgram, data2send)
            onCompleted()
        } catch (error) {
            console.log(error)
        }
        setBusy(false)
    }






    let contentCanvas = null
    let contentSmallCanvas = null
    let contentDownloadButtons = null

    contentDownloadButtons = (
        <div style={{marginTop:16}}>
            <Grid container spacing={1}>
                <Grid item>
                    <Button className={classes.button} onClick={onDownloadSDQRImage}>
                        256px <Icon>file_download</Icon>
                    </Button>
                </Grid>
                <Grid item>
                    <Button className={classes.button} onClick={onDownloadHDQRImage}>
                        512px <Icon>file_download</Icon>
                    </Button>
                </Grid>
            </Grid>
        </div>
    )

    if(form.url.value){

        console.log(origin)

        const urlQR = `${form.url.value}?uuid=${origin?.cardUUID}`
        //console.log(urlQR)
        contentCanvas = (
            <div className={classes.custom_canvas} >
                <QRCodeCanvas
                    id="qrCodeFlexia"
                    value={urlQR}
                    size={config.QR_SIZE_LARGE}
                />
            </div>
            
        )

        contentSmallCanvas = (
            <div className={classes.custom_canvas} >
                <QRCodeCanvas
                    id="qrCodeFlexiaSmall"
                    value={urlQR}
                    size={config.QR_SIZE_SMALL}
                />
            </div>
            
        )

        
    }


    return ( 
        <Dialog open={open} maxWidth='sm' fullWidth classes={{ paper: classes.paper }} className={classes.root}
        TransitionComponent={Transition} onClose={onClose} scroll='body'>
            <div>
                <IconButton className={classes.close_button} onClick={onClose} >
                    <Icon>close</Icon>
                </IconButton>
                <Typography variant='h5' className={classes.title}>
                    {isnew ? 'Generate QR Code' : 'QR Details'}
                </Typography>
                <Typography>
                    <i>
                        {isnew ? 'Please add a valid url to generate the QR Code' : 'If you would like to update the QR Code, please update the form with a valid url and press Save'}
                    </i>
                </Typography>
                <div style={{padding:'24px 0px'}}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <InputForm data={form.url} onChange={onChangeForm} />
                        </Grid>
                    </Grid>
                </div>
                
                {!isnew ? (
                    <div className={classes.image_container} >
                        <img src={origin?.qrCode} alt='' width='100%'/>
                    </div>
                ) : null}
                <div>
                    <Grid container justify='center'>
                        <Grid item>
                            {contentCanvas}
                            {contentSmallCanvas}
                        </Grid>
                        <Grid item>
                            {!isnew ? contentDownloadButtons : null}
                        </Grid>
                    </Grid>
                </div>
                <div style={{marginTop:32, textAlign:'center'}}>
                    <DisplayError>{cardlevelManager.system.error}</DisplayError>
                    <RoundedButton loading={busy} onClick={onUpdateCardLevel}>{isnew ? 'Generate' : 'Update'}</RoundedButton>
                </div>

            </div>

        </Dialog>
     );
}

const useStyles = makeStyles(theme => ({
    paper:{
        borderRadius:32, 
        padding:theme.spacing(5),
        position:'relative',
        [theme.breakpoints.down('sm')]:{
            padding:theme.spacing(3),
            margin:8
        },
        
    },
    root:{
    },
    icon:{
        //color:'white',
        borderRadius:'50%',
        fontSize:54,
        padding:8
    },
    close_button:{
        position:'absolute', right:16, top:16
    },
    image_container:{
        
        width:180, 
        height:180,
        margin:'auto'
    },
    title:{
        color:theme.palette.primary.main,
        fontWeight:600
    },
    custom_canvas:{
        display:'none'
    },
    button:{
        borderRadius:32,
        textTransform:'lowercase',
        background: blueGrey[100],
        '&:hover':{
            background: blueGrey[200],
        }
    }
}))
 
export default ProgramQRModal;

const Transition = React.forwardRef(function Transition(props, ref) {return <Grow ref={ref} {...props} timeout={500} />;});

const form_data = {
    url:{
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config:{
            id:'url',
            type:'url',
            fullWidth: true,
            label:'Url',
            placeholder:'Url',
            helperText:'Invalid Url, must be a valid URL',
        },
        rules:{
            type:'link',
        }
    },
}